import {StillImageBackground} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {GameMode, IGameModeChangedData} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WGGameConfig} from "../WGGameConfig";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {SoundManager} from "../resource/sound/SoundManager";
import {WGSoundConfig} from "../WGSoundConfig";
import {WGGameAssets} from "../WGGameAssets";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";

// SKY TRACK - 0
// RAIN TRACK - 1
// THUNDER TRACK - 2

export interface IAllBackground {
    background: {
        spine: PIXI.spine.Spine
    };
}

export interface IBackgroundData {
    spine: PIXI.spine.Spine
}

export class WGStillImageBackground extends StillImageBackground {
    private _extendReelPillars: PIXI.Container;
    private _reelOverlayLayer: ScalableLayer;
    private _superFsSpine: PIXI.spine.Spine;
    private _backgroundSpriteforSpine:PIXI.Sprite;

    public static _isSuperFreespin: boolean = false;

    private _allBackgroundData: IAllBackground;

    public startFSBgRaining(): void {
        this.startRaining();
    }

    protected initAnimations(): void {
        super.initAnimations();
        this._backgroundSpriteforSpine = new PIXI.Sprite();
        this._layer.addChild(this._backgroundSpriteforSpine);
        this.spineInit();
        this._extendReelPillars = new PIXI.Container();
        // to put pillar + fire above reel area
        this._reelOverlayLayer = StageManager.getLayer(WGGameConfig.instance.LAYERS.REEL_OVERLAY.name);
        this._extendReelPillars.addChild(new PIXI.Sprite(GameResources.getTextures(WGGameAssets.BG_LEFT_PILLAR)[0]));
        this._extendReelPillars.children[0].position.set(-95, 42);
        this._extendReelPillars.addChild(new PIXI.Sprite(GameResources.getTextures(WGGameAssets.BG_RIGHT_PILLAR)[0]));
        this._extendReelPillars.children[1].position.set(718, 42);
        this._superFsSpine = new PIXI.spine.Spine(GameResources.getSpineAsset("superFresspinsIdleAnimation"));
        this._superFsSpine.position.set(355, 355);
        this._superFsSpine.visible = false;
        this.playFireOnPillars();
    }
    protected createSpine(name: string): IBackgroundData {
        const spine = new PIXI.spine.Spine(GameResources.getSpineAsset(name));
        spine.position.set(355, 355);
        this._backgroundSpriteforSpine.removeChildren();
        this._backgroundSpriteforSpine.addChild(spine);
        return {
            spine: spine
        };
    }

    private spineInit(): void {
        this._allBackgroundData = {
            background: this.createSpine("baseGameIdleAnimation")
        };
    }

    protected addEventListeners(): void {
        super.addEventListeners();

        EventHandler.addEventListener(this, SpinEvent.IDLE, () => this.startRaining());
        EventHandler.addEventListener(this, SpinEvent.START, () => this.stopRaining());
    }

    /**
     * function to play pillar fire
     */
    private playFireOnPillars(): void {
        let pillarAnimLeft = new TimelineSprite(GameResources.getTextures("pillar_fire_Animation"), 20);
        pillarAnimLeft.position.set(-72, -7);
        this._reelOverlayLayer.addChildAt(pillarAnimLeft, 0);

        let pillarAnimRight = new TimelineSprite(GameResources.getTextures("pillar_fire_Animation"), 20);
        pillarAnimRight.position.set(731, -8);
        this._reelOverlayLayer.addChildAt(pillarAnimRight, 0);

        pillarAnimLeft.playLoop();
        pillarAnimRight.playLoop();
        this._reelOverlayLayer.addChild(this._extendReelPillars);
    }

    protected onChangeBackground(data: IGameModeChangedData): boolean {
        this._superFsSpine.visible = false;
        this.playBackgroundSpineAnimation(data.newMode);
        if (!super.onChangeBackground(data)) {
            return false;
        }
        this.extendReelPillarsHandling(data.newMode);
        return super.onChangeBackground(data);
    }

    private playSky(mode: string = this._currentMode) {
        if (WGStillImageBackground._isSuperFreespin) {
            return;
        }
        const aniType: string = (mode === GameMode.NORMAL) ? "bg" : "fg";
        this._allBackgroundData.background.spine.state.setAnimationByName(0, `${aniType}_sky`, true);
    }

    private extendReelPillarsHandling(mode: string): void {
        let leftPillartexture: string = (mode === GameMode.NORMAL) ? WGGameAssets.BG_LEFT_PILLAR : "freeGameLeftPillar";
        let rightPillarTexture: string = (mode === GameMode.NORMAL) ? WGGameAssets.BG_RIGHT_PILLAR : "freeGameRightPillar";
        (this._extendReelPillars.children[0] as PIXI.Sprite).texture = GameResources.getTextures(leftPillartexture)[0];
        (this._extendReelPillars.children[1] as PIXI.Sprite).texture = GameResources.getTextures(rightPillarTexture)[0];
    }

    private playBackgroundSpineAnimation(mode: string): void {
        if (mode === GameMode.NORMAL) {
            this._allBackgroundData.background.spine.state.clearTracks();
            this._allBackgroundData = {
                background: this.createSpine("baseGameIdleAnimation")
            }
            this.playSky(mode);
            this.stopRaining();
        } else if (mode === GameMode.FREESPIN && !WGStillImageBackground._isSuperFreespin) {

            this._allBackgroundData.background.spine.state.clearTracks();
            this._allBackgroundData = {
                background: this.createSpine("freeGameIdleAnimation")
            }
            this.playSky(mode);
            this.startRaining(mode);
        } else if (mode === GameMode.FREESPIN && WGStillImageBackground._isSuperFreespin) {
            this._allBackgroundData = {
                background: this.createSpine("freeGameIdleAnimation")
            }
            this._superFsSpine.visible = true;
            this._allBackgroundData.background.spine.state.setAnimationByName(0, "fg_sky", false);
            new SpineTween(this._superFsSpine,0,"sfs_idle",-1)
            this._layer.addChild(this._superFsSpine);

        }

        if ((mode === GameMode.FREESPIN || mode === GameMode.NORMAL) && !WGStillImageBackground._isSuperFreespin) {
            this.addThunderAndRailingToBgInSync(mode);
        }
    }

    public addThunderAndRailingToBgInSync(mode: string) {
        SoundManager.playSoundEffect(WGSoundConfig.instance.BACKGROUND_THUNDER);
        const animType: string = mode === GameMode.NORMAL ? "bg" : "fg";
        this._allBackgroundData.background.spine.state.clearTrack(2);
        this._allBackgroundData.background.spine.state.setAnimationByName(2, animType + "_thunder", false);
    }

    private startRaining(mode: string = this._currentMode): void {
        if (mode === GameMode.FREESPIN) return;
        this.stopRaining();
        SoundManager.fadeInRainSound();
        const animType: string = (mode === GameMode.NORMAL) ? "bg" : "fg";
        this._allBackgroundData.background.spine.state.setAnimationByName(1, `${animType}_rain`, true);
    }

    private stopRaining(): void {
        this._allBackgroundData.background.spine.state.setEmptyAnimation(1, 0);
        SoundManager.fadeOutRainSound();
    }
}